var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserVerificationHigherdeliverabilityGlobalreach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Higher_deliverability_Global_reach",
    "data-name": "Higher deliverability \\u2013 Global reach",
    transform: "translate(-15442 -10866)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_590",
    "data-name": "Ellipse 590",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(15442 10866)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(15482 10905.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19363",
    "data-name": "Path 19363",
    d: "M79.786,20.225l-2.11.669-11.235,1-3.173,5.068-2.3-.732-8.941-8.062-1.3-4.192L48.99,9.506,43.37,4.465l-6.63-1.3L36.588,6.2l6.495,6.338,3.178,3.743-3.573,1.867-2.909-.857-4.358-1.818.148-3.515L29.851,9.609l-1.9,8.264-5.763,1.306.57,4.61,7.509,1.445,1.3-7.366,6.2.916,2.882,1.688h4.623l3.164,6.338,8.389,8.51-.615,3.308-6.764-.862-11.688,5.9L29.339,53.763l-1.1,4.471H25.223L19.594,55.64l-5.467,2.594L15.487,64l2.379-2.743,4.183-.13-.292,5.18,3.465,1.014,3.461,3.887,5.651-1.589,6.455,1.019,7.5,2.015,3.743.44,6.347,7.2,12.249,7.2L62.7,102.64l-8.362,3.887-3.173,8.65-12.1,8.079-1.288,4.659A70.464,70.464,0,0,0,91.726,59.45,70.2,70.2,0,0,0,79.786,20.225Z",
    transform: "translate(49.265 11.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19364",
    "data-name": "Path 19364",
    d: "M78.6,81.078l-5.135-9.52,4.713-9.821-4.713-1.409-5.292-5.314-11.724-2.63L52.561,44.24v4.834H50.846l-10.1-13.7V24.122L33.336,12.079l-11.76,2.1H13.654L9.668,11.563l5.086-4.031L9.681,8.7A70.409,70.409,0,0,0,70.5,114.738a73.811,73.811,0,0,0,8.847-.615l-.736-8.542S81.845,92.9,81.845,92.465,78.6,81.078,78.6,81.078Z",
    transform: "translate(-0.004 26.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19365",
    "data-name": "Path 19365",
    d: "M13.668,22.735l12.523-1.746,5.772-3.164L38.459,19.7l10.378-.575,3.555-5.588,5.184.853,12.591-1.18,3.47-3.824,4.893-3.268L85.45,7.155l2.523-.382A70.275,70.275,0,0,0,3.6,25.634h.036ZM60.942,7.011l7.2-3.963,4.623,2.671-6.692,5.095-6.392.642L56.8,9.588ZM39.617,7.59l3.178,1.324L46.956,7.59l2.267,3.928L39.617,14.04,35,11.338S39.514,8.43,39.617,7.59Z",
    transform: "translate(12.527 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserVerificationHigherdeliverabilityGlobalreach);
export default __webpack_public_path__ + "static/media/User-Verification-Higher deliverability – Global reach.7bd922745914e3fe232e14a389711642.svg";
export { ForwardRef as ReactComponent };